<template>
  <div class="d-flex flex-row">
    <div 
      v-for="(option, index) in options" 
      :key="option.value" 
      class="mr-4"
    >
      <input 
        type="checkbox"
        :id="`check_${option.value}`"
        :checked="isChecked(option.value)"
        @change="updateModel(option)"
        :disabled="disabled"
        class="mr-2"
      >
      <label 
        :for="`check_${option.value}`" 
        :class="{ 'text-gray-400': option.disabled }"
      >
        {{ option.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxComponent',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isChecked(value) {
      // Ensure value is an array
      const currentValue = Array.isArray(this.value) ? this.value : [];
      return currentValue.includes(value);
    },
    updateModel(option) {
      // Ensure value is an array
      const currentValue = Array.isArray(this.value) ? [...this.value] : [];
      
      // Toggle the value
      const newValue = this.isChecked(option.value)
        ? currentValue.filter(v => v !== option.value)
        : [...currentValue, option.value];
      
      // Emit the new value
      this.$emit('input', newValue);
    }
  }
}
</script>
